export default __webpack_public_path__ + "static/usa_montana_cash-3d7fdb969acf98362b4bce6cfb33a61a.png";